import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { useProductResultsContext } from "../../context/productResults.context";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const { showFacets } = useProductResultsContext();

    if (!showFacets) {
        return null;
    }

    return <>{children}</>;
};

export { Base };
